import { useState, useEffect } from 'react'
import s from './ColorPicker.scss'
import { SketchPicker } from 'react-color'
import { OutsideClickContainer } from 'components/ideal-core-ui'

const ColorPicker = ({ color, onChange, style = {} }) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false)
  const [internalColor, setInternalColor] = useState('#737373')

  useEffect(() => {
    if (!color) return
    setInternalColor(color)
  }, [color])

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker)
  }

  const handleClose = () => {
    setDisplayColorPicker(false)
  }

  const handleChange = color => {
    setInternalColor(color.hex)
    onChange?.(color.hex)
  }

  return (
    <OutsideClickContainer styles={{ height: 'initial' }} closeComponent={handleClose}>
      <div title="Select color" className={s.swatch} onClick={handleClick}>
        <div className={s.color} style={{ background: internalColor, ...style }} />
      </div>
      {displayColorPicker ? (
        <div className={s.popover}>
          <div className={s.cover} onClick={handleClose} />
          <SketchPicker color={internalColor} onChange={handleChange} />
        </div>
      ) : null}
    </OutsideClickContainer>
  )
}

export default ColorPicker
